import { useEffect, useState } from "react";
import { DesignTokens } from "melco-ui";
import { useTranslation } from "react-i18next";

import { StepLabel } from "./digitizingOrdersLogsStyled";
import { SearchDigitizingOrdersLogsUser } from "./SearchDigitizingOrdersLogsUser";
import { DigitizingOrdersLogsUsersListFiltersType } from "../../hooks/digitizingorderslogs/DigitizingOrdersLogsUsersListFiltersType";

type DigitizingOrdersLogsListFilterProps = {
  onFiltersChange: (filters: DigitizingOrdersLogsUsersListFiltersType | undefined) => void;
  /** Controlled by the parent (DigitizingOrdersLogsList) rather than tracked locally here,
   * so the parent can reset it (e.g. when the user or search changes)
   * and have the Select actually reflect that reset. */

  setSearchCallback: (searchText: string) => void;

};

const { spacings } = DesignTokens;

// const SearchHint = styled.p`
//   margin-top: 8px;
//   font-size: 12px;
//   color: ${colors.gray.middle};
//   line-height: 1.6;
// `;

export const DigitizingOrdersLogsListFilter: React.FC<DigitizingOrdersLogsListFilterProps> = ({
  onFiltersChange,
  setSearchCallback,
}) => {
  const { t } = useTranslation();

  const [usersFilter, setDigitizingOrdersLogsFilter] = useState<
    DigitizingOrdersLogsUsersListFiltersType | undefined
  >(undefined);

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    onFiltersChange(usersFilter);
  }, [usersFilter, onFiltersChange]);

  return (
    <div style={{ padding: `${spacings.middle}px ${spacings.middle}px ${spacings.small}px` }}>
      <StepLabel>{t("digitizingOrdersLogs.form.panel.step_one_label", { defaultValue: "Step 1 — Find user" })}</StepLabel>

      <SearchDigitizingOrdersLogsUser
        onSearchInputChange={(value) => {
          setDigitizingOrdersLogsFilter((prevFilter: any) => {
            return { ...prevFilter, searchText: value };
          });
        }}
        onChange={(e) => {
          setSearchValue(e.target.value);
          setSearchCallback(e.target.value);
        }}
        value={searchValue}
      />



      {/* <SearchHint>
         {t("digitizingOrdersLogs.form.panel.search_hint", { defaultValue: "Ask for the caller's name or email." })} 
      </SearchHint> */}
    </div>
  );
};
